export function initPublicPasswordVisibility(root = document) {
  root.querySelectorAll('[data-public-password-toggle]').forEach(button => {
    button.hidden = false;
  });
  if (root.documentElement?.dataset.publicPasswordVisibilityBound === 'true') return;
  if (root.documentElement) root.documentElement.dataset.publicPasswordVisibilityBound = 'true';

  root.addEventListener('turbo:render', () => initPublicPasswordVisibility(root));

  root.addEventListener('click', event => {
    const button = event.target.closest('[data-public-password-toggle]');
    if (!button) return;
    const input = button.closest('[data-public-password]')?.querySelector('input');
    if (!input) return;

    const visible = input.type === 'password';
    input.type = visible ? 'text' : 'password';
    button.setAttribute('aria-pressed', String(visible));
    button.textContent = visible ? 'Hide' : 'Show';
    button.setAttribute('aria-label', button.getAttribute('aria-label').replace(visible ? 'Show' : 'Hide', visible ? 'Hide' : 'Show'));
  });

  root.addEventListener('turbo:before-cache', () => {
    root.querySelectorAll('[data-public-password-toggle]').forEach(button => {
      const input = button.closest('[data-public-password]')?.querySelector('input');
      if (input) input.type = 'password';
      button.setAttribute('aria-pressed', 'false');
      button.textContent = 'Show';
      button.setAttribute('aria-label', button.getAttribute('aria-label').replace('Hide', 'Show'));
    });
  });
}
